import axios from 'axios';

const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('lodi_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && !window.location.pathname.startsWith('/login')) {
      localStorage.removeItem('lodi_token');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export const fmtRp = (n) => 'Rp ' + new Intl.NumberFormat('id-ID').format(Math.round(Number(n) || 0));

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return 'Terjadi kesalahan, coba lagi';
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(' ');
  return String(d);
};

let branchCache = [
  { id: 'balaraja', name: 'Balaraja' },
  { id: 'ciledug', name: 'Ciledug' },
];
export const getBranchCache = () => branchCache;
export const setBranchCache = (list) => { if (Array.isArray(list) && list.length) branchCache = list; };

export const branchLabel = (b) => {
  if (!b || b === 'all') return 'Semua Cabang';
  const found = branchCache.find((x) => x.id === b);
  return found ? found.name : b;
};

export const todayStr = () => {
  const d = new Date(Date.now() + 7 * 3600 * 1000);
  return d.toISOString().slice(0, 10);
};

export default api;
